import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { updateFilterItems } from '@utils/utils';
import { I_FilterItem } from '@Redux/search/interfaces';
import { setFilterItems, setChangeItem } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import { Checkbox } from '@lion-design/core';

export interface ItemInfo {
    text: string; // 項目名稱
    value: any; // 項目value
    filterType: string; // 項目所屬大項
}

export interface FilterItemProps extends ItemInfo {
    cols: string;
    note?: string;
    isDisable: boolean; // 是否要disabled
}

const CheckboxItem: React.FC<FilterItemProps> = ({
    text,
    value,
    filterType,
    isDisable,
    note,
    cols,
}) => {
    const dispatch = useDispatch();
    const { FilterItems } = useSelector((state: RootState) => state.search);
    const isCheck = FilterItems.filter((item: I_FilterItem) => {
        return item.filterBy === filterType && item.value == value; // value 可能是string or number 不可用===
    });
    const itemInfo = () => {
        return (
            <>
                <span>{text}</span>
                {note && <span className={styles.Note}>{note}</span>}
            </>
        );
    };

    const checkboxProps = {
        onChange: (active: boolean) => {
            const props = {
                data: FilterItems,
                nowType: filterType,
                value: value,
                text: text,
                subValue: '',
            };
            const newFilterItems = updateFilterItems(props);
            dispatch(setFilterItems(newFilterItems));
            dispatch(setChangeItem(true));
        },
        checked: isCheck.length !== 0,
        title: itemInfo(),
        disabled: isDisable,
        checkFillColor: '#669', //勾勾顏色
        checkedBackgroundColor: 'transparent', //勾起來的時候的背景色
    };

    return (
        <li className={cN(styles.CheckBoxWrap, styles[cols])}>
            <Checkbox {...checkboxProps} />
        </li>
    );
};

export default CheckboxItem;
